/**
 * Campaign Management Tab
 *
 * Main tab component for Campaign Management with 6 sub-tabs
 */
import { type JSX } from 'react'
import { TabView, TabPanel } from 'primereact/tabview'
import { WebContactBasicInfoTab } from './WebContactBasicInfoTab'

export interface WebContactManagementTabProps {
  disabled?: boolean
}

export function WebContactManagementTab({
  disabled = false,
}: WebContactManagementTabProps): JSX.Element {
  return (
    <TabView>
      <TabPanel header="Basic Information">
        <WebContactBasicInfoTab disabled={disabled} />
      </TabPanel>
      
      <TabPanel header="Target Audience">
        <p className="py-4 text-sm text-gray-500">
          Target Audience configuration coming soon...
        </p>
      </TabPanel>
      
      <TabPanel header="Content & Templates">
        <p className="py-4 text-sm text-gray-500">
          Content & Templates configuration coming soon...
        </p>
      </TabPanel>
      
      <TabPanel header="Scheduling">
        <p className="py-4 text-sm text-gray-500">
          Scheduling configuration coming soon...
        </p>
      </TabPanel>
      
      <TabPanel header="Routing & Distribution">
        <p className="py-4 text-sm text-gray-500">
          Routing & Distribution configuration coming soon...
        </p>
      </TabPanel>
      
      <TabPanel header="Advanced Settings">
        <p className="py-4 text-sm text-gray-500">
          Advanced Settings configuration coming soon...
        </p>
      </TabPanel>
    </TabView>
  )
}
